export const FALLBACK_PRODUCT_LABEL = 'Buffer'

export enum ProductName {
  PUBLISH = 'publish',
  ANALYZE = 'analyze',
  ENGAGE = 'engage',
  START_PAGE = 'start-page',
  CREATE = 'create',
  COMMENTS = 'comments',
  ACCOUNT = 'account',
  NEWSETTINGS = 'new-settings',
}

type Port = `:${number}` | ''

export type ProductType<NAME extends ProductName = ProductName> = {
  id: NAME
  label: string
  isNew: boolean
  subdomain: string
  localPort: Port
  pathname?: string
  activeOnMatch?: RegExp
}

// ensure the name is used as the key in the object
export const PRODUCTS: { [key in ProductName]: ProductType<key> } = {
  [ProductName.CREATE]: {
    id: ProductName.CREATE,
    label: 'Create',
    isNew: false,
    subdomain: 'publish',
    localPort: ':8888',
    pathname: 'create',
    activeOnMatch: /(content|create)/,
  },
  [ProductName.PUBLISH]: {
    id: ProductName.PUBLISH,
    label: 'Publish',
    isNew: false,
    subdomain: 'publish',
    localPort: ':8888',
    pathname: '',
  },
  [ProductName.COMMENTS]: {
    id: ProductName.COMMENTS,
    label: 'Community',
    isNew: false,
    subdomain: 'publish',
    localPort: ':8888',
    pathname: 'comments',
  },
  [ProductName.ANALYZE]: {
    id: ProductName.ANALYZE,
    label: 'Analyze',
    isNew: false,
    subdomain: 'analyze',
    localPort: ':8081',
    pathname: '',
  },
  [ProductName.ENGAGE]: {
    id: ProductName.ENGAGE,
    label: 'Engage',
    isNew: false,
    subdomain: 'engage',
    localPort: ':8080',
    pathname: '',
  },
  [ProductName.START_PAGE]: {
    id: ProductName.START_PAGE,
    label: 'Start Page',
    isNew: false,
    subdomain: 'start-page',
    localPort: ':9999',
    pathname: '',
  },
  [ProductName.ACCOUNT]: {
    id: ProductName.ACCOUNT,
    label: 'Account',
    isNew: false,
    subdomain: 'account',
    localPort: ':8080',
    pathname: '',
  },
  [ProductName.NEWSETTINGS]: {
    id: ProductName.NEWSETTINGS,
    label: 'Settings',
    isNew: false,
    subdomain: 'publish',
    localPort: ':8888',
    pathname: 'settings',
  },
}

const PRODUCTS_ARRAY: ProductType[] = Object.values(PRODUCTS)

export const getMainProducts = ({
  showStartPage,
  shouldHideAnalyze = false,
  isOneBufferOrganization = false,
}: {
  showStartPage: boolean
  shouldHideAnalyze?: boolean
  isOneBufferOrganization?: boolean
}): ProductType[] => {
  const baseProducts = [
    PRODUCTS[ProductName.CREATE],
    PRODUCTS[ProductName.PUBLISH],
    isOneBufferOrganization && PRODUCTS[ProductName.COMMENTS],
    !shouldHideAnalyze && PRODUCTS[ProductName.ANALYZE],
  ].filter(Boolean) as ProductType[]

  return showStartPage
    ? [...baseProducts, PRODUCTS[ProductName.START_PAGE]]
    : baseProducts
}

export const findProduct = (
  condition: (product: ProductType) => boolean,
): ProductType | undefined => {
  return PRODUCTS_ARRAY.find(condition)
}
